import { combineReducers } from '@reduxjs/toolkit';

import { placementsStatusSlice } from './placementsStatusSlice';
import { placementsCheckListSlice } from './placementsCheckListSlice';
import { placementsStatusHistorySlice } from './placementsStatusHistorySlice';
import { placementsDefectsSlice } from './placementsDefectsSlice';
import { placementsMediaSlice } from './placementsMediaSlice';
import { placementsFurnitureSlice } from './placementsFurnitureSlice';

export const placements = combineReducers({
  placementsStatus: placementsStatusSlice.reducer,
  placementsMedia: placementsMediaSlice.reducer,
  placementsCheckList: placementsCheckListSlice.reducer,
  placementsDefects: placementsDefectsSlice.reducer,
  placementsStatusHistory: placementsStatusHistorySlice.reducer,
  placementsFurniture: placementsFurnitureSlice.reducer,
});
